import { ContentWrapper } from "@/components/layout/content";
import { ScrambleButton } from "@/components/ui/ScrambleButton";
import { GlitchText } from "@/components/ui/GlitchText";

export function ContactSection() {
  return (
    <section className="py-24 bg-transparent" id="contact">
      <ContentWrapper>
        <div className="max-w-3xl mx-auto">
          <div className="mb-12">
            <h2 className="text-3xl md:text-5xl font-mono font-bold text-gray-50 mb-6">
              <GlitchText
                text="Bereit, das System zu upgraden?"
                glitchClassName="text-emerald-400"
              />
            </h2>
            <p className="text-gray-400 font-sans text-lg md:text-xl leading-relaxed">
              Egal ob Code-Schwachstelle, fehlendes UI-Konzept oder Bedarf an starkem Bildmaterial:
              Lass mich wissen, wo die Lücke klafft. Ich melde mich innerhalb von 24 Stunden.
            </p>
          </div>

          <div className="bg-gray-900 border border-gray-800 p-6 md:p-8 rounded-sm font-mono shadow-2xl relative">
            <div className="absolute top-0 left-0 w-full h-1 bg-emerald-500 opacity-50"></div>

            <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                <label className="text-gray-400 text-sm sm:w-32 whitespace-nowrap">
                  &gt; Name:
                </label>
                <div className="flex flex-1">
                  <span className="text-gray-600 px-2 py-2">[</span>
                  <input
                    type="text"
                    className="flex-1 bg-transparent border-b border-gray-800 px-2 py-2 text-gray-50 focus:outline-none focus:border-emerald-400 transition-colors"
                    placeholder=" "
                  />
                  <span className="text-gray-600 px-2 py-2">]</span>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                <label className="text-gray-400 text-sm sm:w-32 whitespace-nowrap">
                  &gt; E-Mail:
                </label>
                <div className="flex flex-1">
                  <span className="text-gray-600 px-2 py-2">[</span>
                  <input
                    type="email"
                    className="flex-1 bg-transparent border-b border-gray-800 px-2 py-2 text-gray-50 focus:outline-none focus:border-emerald-400 transition-colors"
                    placeholder=" "
                  />
                  <span className="text-gray-600 px-2 py-2">]</span>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
                <label className="text-gray-400 text-sm sm:w-32 whitespace-nowrap pt-2">
                  &gt; Briefing:
                </label>
                <div className="flex flex-1 items-start">
                  <span className="text-gray-600 px-2 py-2">[</span>
                  <textarea
                    rows={4}
                    className="flex-1 bg-transparent border-b border-gray-800 px-2 py-2 text-gray-50 focus:outline-none focus:border-emerald-400 transition-colors resize-none"
                    placeholder=" "
                  />
                  <span className="text-gray-600 px-2 py-2 items-end flex">]</span>
                </div>
              </div>

              <div className="pt-8">
                <ScrambleButton
                  type="submit"
                  text="Execute_Connection"
                  accentColor="emerald"
                  className="w-full md:w-auto"
                />
              </div>
            </form>
          </div>
        </div>
      </ContentWrapper>
    </section>
  );
}
